<template>
	<div class="display-flex flex-row flex-align-center item-container">
		<div class="mr-2">
			<SpaceIconCard>
				<SIcon :name="projectIconIndicatorName" width="10" />
			</SpaceIconCard>
		</div>
		<div class="item-name">
			{{ item.title }}
		</div>
	</div>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
import ProjectService from '@/utils/projects-service';
import SpaceIconCard from '@/views/AppLayout/ManageAndCreate/SpaceIconCard.vue';
export default {
	name: 'ProjectSelectItem',
	mixins: [VModelMixin],
	components: { SpaceIconCard },
	props: { item: { type: Object } },
	computed: {
		isPersonalProject() {
			return ProjectService.isPersonalProject(this.item);
		},
		projectIconIndicatorName() {
			return `${this.isPersonalProject ? 'personal' : 'collaborative'}-space`;
		},
	},
};
</script>

<style lang="scss" scoped>
.item-container {
	height: 44px;
}
.item-name {
	font-size: 14px;
}
</style>
